import React from 'react';
import ProjectList from '../Project';

function Portfolio () {

    return (
        <section>
          <ProjectList />
        </section>
    )
}

export default Portfolio